import { gql } from "@apollo/client";
import {
  PaginatedListMetaNoNestingFragment,
  ProductImageDeepNestingFragment,
  ProductLocationInventoryPricingNoNestingFragment,
  ProductNoNestingFragment,
  ProductDeepNestingFragment,
  ProductOptionNoNestingFragment,
  SelectedOptionNoNestingFragment,
  SuccessDeepNestingFragment,
  ProductIdResultDeepNestingFragment,
  StockNumberNotFoundErrorDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const MUTATION_UPLOAD_PRODUCT_IMAGE = gql`
  mutation createProductImage($input: CreateProductImageInput!) {
    createProductImage(input: $input) {
      ... on ProductImage {
        id
      }
      ... on MimeTypeError {
        message
      }
    }
  }
`;

export const MUTATION_UPLOAD_RETAILER_IMAGE = gql`
  ${SuccessDeepNestingFragment}
  mutation uploadImageToRetailerBySKU(
    $input: UploadImageToRetailerBySKUInput!
  ) {
    uploadImageToRetailerBySKU(input: $input) {
      ...SuccessDeepNesting
    }
  }
`;

export const productsQuery = gql`
  ${ProductNoNestingFragment}
  ${ProductLocationInventoryPricingNoNestingFragment}
  ${ProductOptionNoNestingFragment}
  ${SelectedOptionNoNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
  query GetProducts($options: ProductListOptions) {
    products(options: $options) {
      items {
        ...ProductNoNesting
        locationInventoryPricing {
          ...ProductLocationInventoryPricingNoNesting
        }
        options {
          ...ProductOptionNoNesting
        }
        selectedOptions {
          ...SelectedOptionNoNesting
        }
        image {
          path
        }
        imageCount
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;

export const PRODUCT_QUERY = gql`
  ${ProductNoNestingFragment}
  ${ProductLocationInventoryPricingNoNestingFragment}
  ${ProductOptionNoNestingFragment}
  ${SelectedOptionNoNestingFragment}
  query GetProduct($id: ID!) {
    product(id: $id) {
      ...ProductNoNesting
      locationInventoryPricing {
        ...ProductLocationInventoryPricingNoNesting
      }
      options {
        ...ProductOptionNoNesting
      }
      selectedOptions {
        ...SelectedOptionNoNesting
      }
      image {
        path
      }
    }
  }
`;

export const PRODUCT_IMAGES_QUERY = gql`
  ${ProductImageDeepNestingFragment}
  query GetProductImages($productId: ID!) {
    productImages(productId: $productId) {
      ...ProductImageDeepNesting
    }
  }
`;

export const PRODUCT_ID_BY_STOCK_NUMBER_QUERY = gql`
  ${ProductIdResultDeepNestingFragment}
  ${StockNumberNotFoundErrorDeepNestingFragment}
  query GetProductIdByStockNumber($stockNumber: String!) {
    productIdByStockNumber(stockNumber: $stockNumber) {
      ... on ProductIdResult {
        ...ProductIdResultDeepNesting
      }
      ... on StockNumberNotFoundError {
        ...StockNumberNotFoundErrorDeepNesting
      }
    }
  }
`;
